import { FC } from 'react';
import styled from 'styled-components';
import { AllieButton, AllieText } from '../../../components';

const ContentLoadingStyled = styled.div`
  display: grid;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  box-sizing: border-box;
  padding: 30px;
  row-gap: 16px;
  width: 392px;
  margin: 0 auto;

  ion-button {
    flex: 1;
  }

  .po-ended-button-cancel {
    --background: var(--allie-color-primary-50);
    --color: var(--allie-color-primary-70);
    --ion-color-contrast: var(--allie-color-primary-70);
  }
`;

export interface EfficiencyWizardEndedProps {
  labels: {
    title: string;
    text?: string;
    button: string;
    buttonSecondary?: string;
  };
  value?: string;
  className?: string;
  onClick?: () => void;
  onClickSecondaryButton?: () => void;
}

export const EfficiencyWizardEnded: FC<EfficiencyWizardEndedProps> = ({
  labels,
  className,
  value,
  onClick,
  onClickSecondaryButton,
}) => {
  const { title, text, button, buttonSecondary } = labels;

  return (
    <ContentLoadingStyled className={className}>
      <AllieText color="neutral-90" type="h2">
        {title}
      </AllieText>
      <div>
        {text && (
          <AllieText color="neutral-90" type="h4" weight={400}>
            {text}
          </AllieText>
        )}
        <AllieText color="neutral-90" type="h4" weight={700}>
          {value}
        </AllieText>
      </div>
      <div style={{ display: 'flex', columnGap: '12px' }}>
        {onClickSecondaryButton && buttonSecondary && (
          <AllieButton
            color="light"
            className="po-ended-button-cancel"
            allieSize="medium"
            onclick={onClick}
            corner="rounded-edges"
          >
            {buttonSecondary}
          </AllieButton>
        )}
        <AllieButton allieSize="medium" onclick={onClick} corner="rounded-edges">
          {button}
        </AllieButton>
      </div>
    </ContentLoadingStyled>
  );
};
